<template>
  <div class="menuBody" >
    <ReportTree @ReportTree="getMsgFormSon"/>
        <OfflineListDiaLog ref="OfflineListDiaLog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                电票列表 <!--  收费报表管理--电票列表  -->
            <div style="float:right;margin-right:10px;margin-top:-10px;display:none;">
               <el-button type="primary"  size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;"  @click="Derive()">导出</el-button>
            </div>

            </div>
              <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
              <div style="width:150px;float:left;margin-right:15px;margin-bottom:10px">
                 <el-input placeholder="请输入支付方式" size="small"  v-model="paymentTy" ></el-input>
            </div>
              <div style="width:150px;float:left;margin-right:15px;margin-bottom:10px">
                 <el-input placeholder="请输入房间号" size="small"  v-model="roomId"></el-input>
            </div>
              <div style="width:150px;float:left;margin-right:15px;margin-bottom:10px">
                 <el-input placeholder="请输入业主名称" size="small"  v-model="ownerName"></el-input>
            </div>
                          <div style="width:150px;float:left;margin-right:15px;margin-bottom:10px">
                 <el-input placeholder="请输入抬头名称" size="small"   v-model="riseName"></el-input>
            </div>
                          <div style="width:150px;float:left;margin-right:15px;margin-bottom:10px">
                 <el-input placeholder="请输入流水号" size="small"  v-model="runningName"></el-input>
            </div>
                         <div style="width:170px;float:left;margin-right:15px;margin-bottom:10px">
                <el-select  clearable v-model="value" placeholder="请选择开票状态"  size="small" @change="InvoiceTy(value)">
                    <el-option v-for="item in invoiceType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cr:sOfflineETicket:offlineList'" @click="Inquire()">查询</el-button>
            </div>

             <el-table   
      border   :data="tableData" tooltip-effect="light"   v-loading="loading" style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="fpqqlsh" label="流水号"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="fphm" label="发票号码"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
    <el-table-column show-overflow-tooltip prop="floorName" label="楼宇名称"></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomName" label="房间名称"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="cusName" label="业主姓名"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="gmfMc" label="抬头名称"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="money" label="金额"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="makeinvoiceDate" label="请求开票日期"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="formatDate" label="税控开票日期"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收款方式"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="voucherStatus" label="凭证状态"  >
        <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.voucherStatus=='9'" >上传失败</el-tag>
            <el-tag type="success" v-if="scope.row.voucherStatus=='1'" >已上传</el-tag>
            <el-tag type="warning" v-if="scope.row.voucherStatus=='0'" >待上传</el-tag>
            <el-tag type="warning" v-if="scope.row.voucherStatus==null" >未上传</el-tag>
        </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="voucherNum" label="凭证编号"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceStatus" label="开票状态"  >
        <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.invoiceStatus=='2'" >开票中</el-tag>
            <el-tag type="success" v-if="scope.row.invoiceStatus=='3'" >开票失败</el-tag>
            <el-tag type="warning" v-if="scope.row.invoiceStatus=='4'" >开票成功</el-tag>
            <el-tag type="warning" v-if="scope.row.invoiceStatus=='5'" >封账待开</el-tag>
            <el-tag type="warning" v-if="scope.row.invoiceStatus==null" >未开</el-tag>
        </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注" ></el-table-column>
    <el-table-column fixed="right" label="操作"  width="150px" >
      <template slot-scope="scope">
        <el-button @click="editMenu(scope.row)" v-Jurisdiction="'expense:web:cr:sOfflineETicket:parIct'" type="primary" icon="el-icon-edit"  circle size="small" title="查看"></el-button>
        <el-button @click="delMenu(scope.row)"  v-Jurisdiction="'expense:web:cr:sOfflineETicket:refund'" type="danger" v-show="scope.row.isRed != '1' && scope.row.money > 0 && scope.row.invoiceStatus == '4'" icon="el-icon-delete" circle size="small" title="红冲"></el-button>
      </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import OfflineListDiaLog from "./OfflineListDiaLog";
import ReportTree from "./ReportTree.vue";
export default {
  name: "OfflineList",
  components: {ReportTree,OfflineListDiaLog},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        AllData:"",
        DateTime:"",
        paymentTy:"",
        roomId:"",
        ownerName:"",
        riseName:"",
        runningName:"",
        invoiceType:[{
          value:"2",
          label:"开票中",
        },
        {
          value:"3",
          label:"开票失败",
        },
        {
          value:"4",
          label:"开票成功",
        },{
          value:"5",
          label:"封账待开",
        }],
        value:"",
        tableData:[],
        coplistArr:[],
        melistArr:[],
        DayCollectArr:[],
          list: [],
      listLoading: true,
      dynamicValidateForm: {
        domains: []
      },
      startInDate:"",
      endInDate:"",
    }
  },
  methods: {
    BillDateTime(){
        var d = this.DateTime[0];
          var done = this.DateTime[1]
          this.startInDate = d.getTime()
          this.endInDate = done.getTime()
    },
    Inquire(){
    // 查询
    this.loading = true
      let paymentTy = this.paymentTy
      let roomId = this.roomId
      let ownerName = this.ownerName
      let riseName = this.riseName
      let runningName = this.runningName
      let invoiceType = this.value
      let obj = {
        "payMethod":paymentTy,  // 支付方式
        "roomName":roomId,// 房间号
        "cusName":ownerName, // 业主名称
        "gmfMc":riseName, // 抬头名称
        "fpqqlsh":runningName,// 流水号
        "invoiceStatus":invoiceType, // 开票状态
        "startskrq":this.startInDate, // 开始时间
        "endskrq":this.endInDate, // 结束时间
        "projectIds":this.projectId,
        "page":this.currentPage,
        "size":this.pagesize
      }
       this.$http.post(this.$requestUrl.POST_OFFLINE_BILLS,obj).then((res) => {
          let data = res.data.data.records;
             this.tableData = data ;
             this.loading = false
             this.paymentTy = ""
             this.roomId = ""
             this.ownerName = ""
             this.riseName = ""
             this.runningName = ""
             this.DateTime = []
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })

    },
    InvoiceTy(val){
    },
    delMenu(res){
      console.log(res)
         this.$confirm('此操作将确认红冲作废吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      let obj = {
        "num":res.fpqqlsh,
        "type":1,
        "projectId":res.projectId,
        "billIds":res.billIds
      } 
      this.$http.post(this.$requestUrl.POST_OFFLINE_REDDASHED,obj).then((res) => {
        if(res.data.code == 200){
          this.$message({
            type: 'success',
            message: '红冲成功!'
          });
          this.ShareList()
        }else{
            this.$message({
            type: 'warning',
            message: res.data.msg
          });
        }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消红冲'
          });          
        });
      },
    Derive(){
        
    },
    editMenu(res){
      // 查看
      let obj = {
        "id":res.id,
      }
       this.$http.post(this.$requestUrl.POST_OFFLINE_CHECK,obj).then((res) => {
         if(res.data.code == 200){
           this.$refs.OfflineListDiaLog.dialogVisible = true
           this.$refs.OfflineListDiaLog.dataS = res.data.data
           this.$refs.OfflineListDiaLog.title = "订单详情"
         }else{

         }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })

    },
    getMsgFormSon(data){
      this.loading = true
        let arr = []
      arr.push(data.id)
      this.projectId = arr
        this.mangroupId = data.value
        this.mangrouplab = data.label
        this.ShareList()
      this.AllData = data
    },
   handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    ShareList(){
      let obj = {
        "projectIds":this.projectId,
        "page":this.currentPage,
        "size":this.pagesize,
        "startskrq":"",
        "endskrq":"",
      }
        this.$http.post(this.$requestUrl.POST_OFFLINE_BILLS,obj).then((res) => {
          if(res.data.code == 200){
               let data = res.data.data.records;
            this.total = res.data.data.total
             this.tableData = data ;
             this.loading =false
          }else{
            this.loading =false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
    }, 
    NodeData(data){
    
    },
  },
  mounted() {
          
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>